// File: components/Payments/PaymentCard.jsx
import React from 'react';
import { formatCurrency, parseCurrency, formatDateForDisplay } from '../../utils/format';

const PaymentCard = ({ payment, onClick }) => {
  const isABN = payment.type === 'ABN';
  const status = isABN ? payment[3] : payment[17];
  const amount = isABN
    ? formatCurrency(parseCurrency(payment[7]))
    : formatCurrency(parseCurrency(payment[4]));
  const name = isABN ? payment[15] : payment[16];
  const date = formatDateForDisplay(payment[2]);

  /* Dynamic badge classes */
  const typeClass = isABN ? 'fp-badge-type-abn' : 'fp-badge-type-tfn';

  const getStatusClass = () => {
    if (isABN) {
      if (status === 'Paid') return 'fp-badge-green';
      if (status === 'Waiting For Invoice') return 'fp-badge-amber';
      if (status === 'Waiting Approval') return 'fp-badge-amber';
      if (status === 'In Progress') return 'fp-badge-blue';
      if (status === 'ON HOLD') return 'fp-badge-red';
      if (status === 'Yes Invoice') return 'fp-badge-teal';
      if (status === 'Pending Payment') return 'fp-badge-purple';
      if (status === 'Creating PO Document') return 'fp-badge-indigo';
      if (status === 'Send Purchase Order') return 'fp-badge-indigo';
      return 'fp-badge-blue';
    }
    return status === 'Paid' ? 'fp-badge-green' : 'fp-badge-red';
  };

  return (
    <button className="fp-card" onClick={onClick}>
      <div className="fp-card-top">
        <span className={`fp-badge fp-badge-sm ${typeClass}`}>{payment.type}</span>
        <span className={`fp-badge fp-badge-sm ${getStatusClass()}`}>{status}</span>
      </div>
      <div className="fp-card-mid">
        <p className="fp-card-name">{name}</p>
        <p className="fp-card-amount">{amount}</p>
      </div>
      <div className="fp-card-bottom">
        <span className="fp-card-date">{date}</span>
        {isABN && payment[4] && (
          <span className="fp-card-po">PO: {payment[4]}</span>
        )}

      </div>
      <div className="fr-card-tap-hint">Tap to open</div>
    </button>
  );
};

export default PaymentCard;